// UI Constants
export const UI_CONSTANTS = {
  // Page Titles
  PAGE_TITLES: {
    LOGIN: "Login",
    DASHBOARD: "Dashboard",
    CUISINE_LIST: "Cuisine List",
    ADD_CUISINE: "Add Cuisine",
    UPDATE_CUISINE: "Update Cuisine",
    DISH_CATEGORIES: "Dish Categories",
    ADD_DISH: "Add Dish Category",
    UPDATE_DISH: "Update Dish",
    INGREDIENT_LIST: "Ingredient List",
    ADD_INGREDIENT: "Add Ingredient",
    UPDATE_INGREDIENT: "Update Ingredient",
    MEAL_TYPE: "Meal Type",
    ADD_MEAL_TYPE: "Add Meal Type",
    UPDATE_MEAL_TYPE: "Update Meal Type",
    ALLERGIES: "Allergies",
    ADD_ALLERGY: "Add Allergy",
    UPDATE_ALLERGY: "Update Allergy",
    CUSTOMER_MANAGEMENT: "Customer Management",
    VIEW_CUSTOMER: "View Customer",
    BANNER_MANAGEMENT: "Banner Management",
    ADD_BANNER: "Add Banner",
    UPDATE_BANNER: "Update Banner",
    USERS : "Users"
  },

  // Form Labels
  FORM_LABELS: {
    ALLERGY_NAME: "Allergy Name *",
    INGREDIENT_TYPE: "Ingredient Type *",
    INGREDIENT_NAME: "Ingredient Name *",
    DISH_CATEGORY_NAME: "Dish Category Name *",
    CUISINE_NAME: "Cuisine Name *",
    MEAL_TYPE_TITLE: "Meal Type Title *",
    EMAIL: "Email",
    PASSWORD: "Password",
    CUSTOMER_NAME: "Customer Name",
    CUSTOMER_EMAIL: "Customer Email",
    CUSTOMER_MOBILE: "Customer Mobile",
    SELECTED_INGREDIENTS: "Selected Ingredients:",
    BANNER_TITLE: "Banner Title *",
    BANNER_DESCRIPTION: "Banner Description *",
    BANNER_IMAGE: "Banner Image *",
  },

  // Placeholders
  PLACEHOLDERS: {
    ENTER_ALLERGY_NAME: "Enter allergy name",
    ENTER_INGREDIENT_NAME: "Enter ingredient name",
    ENTER_DISH_CATEGORY_NAME: "Enter dish category name",
    ENTER_CUISINE_NAME: "Enter cuisine name",
    ENTER_MEAL_TYPE_TITLE: "Enter meal type title",
    CLICK_TO_SELECT_INGREDIENTS: "Click to select ingredients",
    SEARCH: "Search",
    ENTER_EMAIL: "Enter email",
    ENTER_PASSWORD: "Enter password",
    DISH_CATEGORY_NAME: "Dish Category Name",
    SELECT_SIZE: "Select Size",
    ENTER_BANNER_TITLE: "Enter banner title",
    ENTER_BANNER_DESCRIPTION: "Enter banner description",
    SELECT_BANNER_IMAGE: "Upload photo",
  },

  // Button Labels
  BUTTON_LABELS: {
    ADD: "Add",
    UPDATE: "Update",
    CANCEL: "Cancel",
    DELETE: "Delete",
    EDIT: "Edit",
    VIEW: "View",
    LOGIN: "Login",
    SAVE: "Save",
    SUBMIT: "Submit",
    ADD_NEW: "Add New +",
    CREATE_NEW: "Create New",
    FORGOT_PASSWORD: "Forgot Password?",
    RESET_PASSWORD: "Reset Password",
    ADDING: "Adding...",
    UPDATING: "Updating...",
    LOADING: "Loading...",
    PREVIOUS: "Previous",
    NEXT: "Next",
    ENTER_NOW: "Enter Now",
    PLAY_NOW: "Play now",
    WATCH_NOW: "Watch Now",
    READ_MORE : "Read More"
  },

  // Section Headers
  SECTION_HEADERS: {
    ADD_ALLERGEN_ITEM: "ADD ALLERGEN ITEM",
    UPDATE_ALLERGY: "UPDATE ALLERGY",
    ADD_INGREDIENT: "ADD INGREDIENT",
    UPDATE_INGREDIENT: "UPDATE INGREDIENT",
    ADD_DISH_CATEGORY: "ADD DISH CATEGORY",
    UPDATE_DISH_CATEGORY: "UPDATE DISH CATEGORY",
    ADD_CUISINE: "ADD CUISINE",
    UPDATE_CUISINE: "UPDATE CUISINE",
    ADD_MEAL_TYPE: "ADD MEAL TYPE",
    UPDATE_MEAL_TYPE: "UPDATE MEAL TYPE",
    ADD_BANNER: "ADD BANNER",
    UPDATE_BANNER: "UPDATE BANNER",
  },

  // Table Headers
  TABLE_HEADERS: {
    ID: "ID",
    NAME: "Name",
    TITLE: "Title",
    DESCRIPTION: "Description",
    INGREDIENTS: "Ingredients",
    STATUS: "Status",
    ACTIONS: "Actions",
    MOBILE_NUMBER: "Mobile Number",
    EMAIL: "Email",
    GENDER: "Gender",
    PROFILE_COMPLETE: "Profile Complete",
    OTP_VERIFIED: "OTP Verified",
    CREATED_DATE: "Created Date",
    SR_NO: "Sr. No",
    IMAGE: "Image",
  },

  // Toast Messages
  TOAST_MESSAGES: {
    SUCCESS: {
      ALLERGY_ADDED: "Allergy added successfully!",
      ALLERGY_UPDATED: "Allergy updated successfully!",
      ALLERGY_DELETED: "Allergy deleted successfully!",
      INGREDIENT_ADDED: "Ingredient added successfully!",
      INGREDIENT_UPDATED: "Ingredient updated successfully!",
      INGREDIENT_DELETED: "Ingredient deleted successfully!",
      DISH_CATEGORY_ADDED: "Dish category added successfully!",
      DISH_CATEGORY_UPDATED: "Dish category updated successfully!",
      DISH_CATEGORY_DELETED: "Dish category deleted successfully!",
      CUISINE_ADDED: "Cuisine added successfully!",
      CUISINE_UPDATED: "Cuisine updated successfully!",
      CUISINE_DELETED: "Cuisine deleted successfully!",
      MEAL_TYPE_ADDED: "Meal type added successfully!",
      MEAL_TYPE_UPDATED: "Meal type updated successfully!",
      MEAL_TYPE_DELETED: "Meal type deleted successfully!",
      STATUS_UPDATED: "Status updated successfully!",
      CUSTOMER_STATUS_UPDATED: "Customer status updated successfully!",
      BANNER_ADDED: "Banner created successfully!",
      BANNER_UPDATED: "Banner updated successfully!",
      BANNER_DELETED: "Banner deleted successfully!",
      VARIATION_ADDED: "Variation added successfully!",
    },
    ERROR: {
      ALLERGY_ADD_FAILED: "Failed to add allergy",
      ALLERGY_UPDATE_FAILED: "Failed to update allergy",
      ALLERGY_DELETE_FAILED: "Failed to delete allergy",
      INGREDIENT_ADD_FAILED: "Failed to add ingredient",
      INGREDIENT_UPDATE_FAILED: "Failed to update ingredient",
      INGREDIENT_DELETE_FAILED: "Failed to delete ingredient",
      DISH_CATEGORY_ADD_FAILED: "Failed to add dish category",
      DISH_CATEGORY_UPDATE_FAILED: "Failed to update dish category",
      DISH_CATEGORY_DELETE_FAILED: "Failed to delete dish category",
      CUISINE_ADD_FAILED: "Failed to add cuisine",
      CUISINE_UPDATE_FAILED: "Failed to update cuisine",
      CUISINE_DELETE_FAILED: "Failed to delete cuisine",
      MEAL_TYPE_ADD_FAILED: "Failed to add meal type",
      MEAL_TYPE_UPDATE_FAILED: "Failed to update meal type",
      MEAL_TYPE_DELETE_FAILED: "Failed to delete meal type",
      STATUS_UPDATE_FAILED: "Failed to update status",
      CUSTOMER_STATUS_UPDATE_FAILED: "Failed to update customer status",
      BANNER_ADD_FAILED: "Failed to create banner",
      BANNER_UPDATE_FAILED: "Failed to update banner",
      BANNER_DELETE_FAILED: "Failed to delete banner",
      BANNER_FETCH_FAILED: "Failed to fetch banners",
      BANNER_DETAILS_FAILED: "Failed to fetch banner details",
      GENERIC_ERROR: "An error occurred. Please try again.",
    },
    VALIDATION: {
      ENTER_ALLERGY_NAME: "Please enter allergy name",
      ENTER_INGREDIENT_NAME: "Please enter ingredient name",
      ENTER_DISH_CATEGORY_NAME: "Please enter dish category name",
      ENTER_CUISINE_NAME: "Please enter cuisine name",
      ENTER_MEAL_TYPE_TITLE: "Please enter meal type title",
      SELECT_INGREDIENTS: "Please select at least one ingredient",
      ENTER_EMAIL: "Please enter email",
      ENTER_PASSWORD: "Please enter password",
      INVALID_EMAIL: "Please enter a valid email",
      PASSWORD_TOO_SHORT: "Password must be at least 6 characters",
      ENTER_BANNER_TITLE: "Please enter banner title",
      ENTER_BANNER_DESCRIPTION: "Please enter banner description",
      SELECT_BANNER_IMAGE: "Please select a banner image",
      ENTER_VARIATION_NAME: "Please enter variation name",
    },
  },

  // Empty States
  EMPTY_STATES: {
    NO_DATA_FOUND: "No Data Found",
    NO_INGREDIENTS_AVAILABLE: "No more ingredients available",
    LOADING_CUSTOMER_DETAILS: "Loading customer details...",
    CUSTOMER_NOT_FOUND: "Customer not found or failed to load.",
  },

  // Confirmation Messages
  CONFIRMATION_MESSAGES: {
    DELETE_ALLERGY: "Are you sure you want to delete this allergy?",
    DELETE_INGREDIENT: "Are you sure you want to delete this ingredient?",
    DELETE_DISH_CATEGORY: "Are you sure you want to delete this dish category?",
    DELETE_CUISINE: "Are you sure you want to delete this cuisine?",
    DELETE_MEAL_TYPE: "Are you sure you want to delete this meal type?",
    DELETE_BANNER: "Are you sure you want to delete this banner?",
  },

  // Status Values
  STATUS: {
    ACTIVE: 1,
    INACTIVE: 0,
    ACTIVE_TEXT: "Active",
    INACTIVE_TEXT: "Inactive",
  },

  // API Response Codes
  API_CODES: {
    SUCCESS: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  },

  // Local Storage Keys
  LOCAL_STORAGE_KEYS: {
    SELECTED_ALLERGY: "selectedAllergy",
    SELECTED_INGREDIENT: "selectedIngredient",
    SELECTED_DISH_CATEGORY: "selectedDishCategory",
    SELECTED_CUISINE: "selectedCuisine",
    SELECTED_MEAL_TYPE: "selectedMealType",
  },

  // Routes
  ROUTES: {
    LOGIN: "/login",
    DASHBOARD: "/dashboard",
    CUISINE_LIST: "/cuisine-list",
    ADD_CUISINE: "/cuisine-list/add-cuisine",
    EDIT_CUISINE: "/cuisine-list/edit-cuisine",
    DISH_CATEGORIES: "/dish-categories",
    ADD_DISH: "/dish-categories/add-dish",
    EDIT_DISH: "/dish-categories/edit-dish",
    INGREDIENT_LIST: "/ingrident",
    ADD_INGREDIENT: "/ingrident/add-ingrident",
    EDIT_INGREDIENT: "/ingrident/edit-ingrident",
    MEAL_TYPE: "/meal-type",
    ADD_MEAL_TYPE: "/meal-type/add-meal",
    EDIT_MEAL_TYPE: "/meal-type/edit-meal",
    ALLERGIES: "/alergies",
    ADD_ALLERGY: "/alergies/add-allergen-item",
    EDIT_ALLERGY: "/alergies/edit-allergy",
    CUSTOMER_MANAGEMENT: "/customer-management",
    VIEW_CUSTOMER: "/view-customer",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    BANNER_MANAGEMENT: "/banner-management",
    ADD_BANNER: "/add-banner",
    EDIT_BANNER: "/edit-banner",
    VARIATION_LIST: "/variations",
    NOTIFICATION_LIST : "/notification"
  },

  // Pagination
  PAGINATION: {
    DEFAULT_LIMIT: 5,
    DEFAULT_PAGE: 1,
  },

  // Styling Constants
  STYLES: {
    DARK_INPUT: {
      backgroundColor: "#1f2937",
      color: "white",
      border: "1px solid #374151",
    },
    DROPDOWN_Z_INDEX: 1000,
    DROPDOWN_MAX_HEIGHT: "200px",
    BADGE_STYLE: {
      fontSize: "12px",
      padding: "5px 10px",
    },
  },

  // Form Validation
  VALIDATION: {
    MIN_PASSWORD_LENGTH: 6,
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },

  // Timeouts
  TIMEOUTS: {
    REDIRECT_DELAY: 1000,
    TOAST_DURATION: 3000,
  },
};

// Export individual constants for easier imports
export const {
  PAGE_TITLES,
  FORM_LABELS,
  PLACEHOLDERS,
  BUTTON_LABELS,
  SECTION_HEADERS,
  TABLE_HEADERS,
  TOAST_MESSAGES,
  EMPTY_STATES,
  CONFIRMATION_MESSAGES,
  STATUS,
  API_CODES,
  LOCAL_STORAGE_KEYS,
  ROUTES,
  PAGINATION,
  STYLES,
  VALIDATION,
  TIMEOUTS,
} = UI_CONSTANTS;
